import { matchPath } from 'react-router-dom';

type RouteParams = {
  [key: string]: string;
};

type LocationParams = {
  params: RouteParams | null;
  query: URLSearchParams | null;
  isExact: boolean;
};

export const getLocationParams = (pathname: string, pathPattern: string): LocationParams => {
  const match = matchPath(pathname, {
    path: pathPattern,
    exact: true,
  });

  const searchParams = new URLSearchParams(window.location.search);

  return {
    params: match ? match.params : null,
    query: searchParams,
    isExact: match ? match.isExact : false,
  };
};
